import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";

@Injectable({
  providedIn: 'root'
})
export class ServiceRequestsService {
  private readonly apiService = inject(BaseApiService);

  async createServiceRequest(company_id: string, location_id: string, depot_id: string, assets_data: string, attachments: any) {
    const body = {
      company_id: company_id,
      location_id: location_id,
      depot_id: depot_id,
      assets_data: assets_data,
      attachments: attachments
    };
    return await this.apiService.post(`/service-request`, body);
  }

  async getServiceRequests(offset: number, limit: number, search: string, order: any, locationId: string, statusId: string, statusCategoryId: string) {
    const body = {
      offset: offset,
      limit: limit,
      search: search,
      sort: JSON.stringify(order),
      locationId: locationId == '0' || !locationId ? null : locationId,
      statusId: statusId || null,
      status_category_id: statusCategoryId
    };
    return await this.apiService.post('/service-request/get', body);
  }

  async getLocations() {
    return await this.apiService.get(`/locations`);
  }

  async getServiceRequestsStatuses() {
    return await this.apiService.get(`/service-request/service-requests-statuses`);
  }

  async getServiceRequestDepots() {
    return await this.apiService.get(`/service-request/service-requests-depots`);
  }

  GetServiceRequestPdf(id: string) {
    return this.apiService.post(`/service-request/${id}/update-preview`, {});
  }
}
